<template>
  <LoadingRights>
    <div class="overflow-y-auto h-full w-full bg-white">
      <slot />
    </div>
  </LoadingRights>
</template>
